import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { CampaignListPage } from '@/features/marketing-shared/ui/campaign-list-page';
import type { MarketingCampaignRow } from '@/features/marketing-shared/model/campaign-filters';
import { useChannelQuotas } from '@/features/channel-quota/model/use-channel-quotas';
import { CapacityBanner } from '@/features/marketing-shared';
import { usePassbook } from '@/shared/lib/passbook';
import { SmsCampaignActions } from './campaign-actions';
import { useSmsMarketing } from '../model/context';
import { useSmsMarketingPaths } from '../model/paths';

export function SmsCampaignsPage() {
  const navigate = useNavigate();
  const { idPassbook } = usePassbook();
  const { campaigns, campaignsState } = useSmsMarketing();
  const { quotas, live } = useChannelQuotas(idPassbook);
  const paths = useSmsMarketingPaths();
  const rows = useMemo<MarketingCampaignRow[]>(
    () =>
      campaigns.map((campaign) => ({
        id: campaign.id,
        name: campaign.name,
        status: campaign.status,
        audienceName: campaign.audience.audienceName,
        eligible: campaign.audience.eligible,
        scheduledAt: campaign.scheduledAt,
        createdAt: campaign.createdAt,
        sendMode: campaign.sendMode,
        sent: campaign.metrics?.sent,
      })),
    [campaigns],
  );

  return (
    <CampaignListPage
      title="SMS"
      icon={MessageSquare}
      phase={campaignsState.phase}
      error={campaignsState.error}
      onRetry={campaignsState.refetch}
      loadingLabel="Carregando campanhas de SMS"
      errorTitle="Não foi possível carregar as campanhas"
      rows={rows}
      emptyTitle="Nenhuma campanha de SMS"
      emptyDescription="Crie a primeira: escolha o público, escreva o texto e aprove o agendamento. O envio sai pela agenda do FixeCRM."
      selectAllId="select-all-sms-campaigns"
      banner={quotas ? <CapacityBanner capacity={quotas.sms} channel="sms" live={live} /> : null}
      onCreate={() => navigate(paths.create)}
      onOpen={(row) => navigate(paths.detail(row.id))}
      renderActions={(row) => <SmsCampaignActions campaign={{ id: row.id, name: row.name, status: row.status }} />}
    />
  );
}
